import { render, staticRenderFns } from "./CheckBillsTable.vue?vue&type=template&id=6d06452b&scoped=true"
import script from "./CheckBillsTable.vue?vue&type=script&lang=js"
export * from "./CheckBillsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d06452b",
  null
  
)

export default component.exports